import React from 'react';
import AllPatients from '../../components/AllPatients';
import WithHeader from '../../components/SearchAndAddPatientsHeader/WithHeader';
import PatientHeader from './PatientHeader';

const PatientsHome = () => {
    return (
        <>
            <AllPatients />
        </>
    );
};

export default WithHeader(PatientsHome, PatientHeader);
